import { defineMessages } from "react-intl";

const messages = defineMessages({
    apply: {
        id: "choir.form.apply",
    },
});

export default messages;
